export const environment = {
  production: true,
  apiUrl: 'https://api.pxremit.com',
};
